export const assetClassEnum = {
  mbus: 'mbus',
  evinox: 'evinox',
  integration: 'integration',
  none: 'none',
} as const

export type AssetClassEnum = (typeof assetClassEnum)[keyof typeof assetClassEnum]

export type AssetClass = AssetClassEnum